import React from 'react';
import { AlertTriangle, Ban } from 'lucide-react';

// Hinweis im Lösch-Dialog: welche In-House-Daten mitgelöscht werden bzw. was das Löschen blockiert.
export function DeleteImpactNotice({ impact }) {
    if (!impact || (!impact.in_house_bookings && !impact.invoices)) return null;
    const blocked = impact.paid_invoice_numbers?.length > 0;
    if (blocked) {
        return (
            <div className="border rounded-lg p-3 bg-red-50 border-red-200 text-sm text-red-900 flex gap-2" data-testid="delete-impact-blocked">
                <Ban className="h-4 w-4 mt-0.5 shrink-0" />
                <div>
                    <div className="font-semibold">Löschen nicht möglich</div>
                    Für diesen Kurs gibt es bereits bezahlte Sammelrechnungen ({impact.paid_invoice_numbers.join(', ')}).
                    Diese müssen aufbewahrt werden (GoBD).
                </div>
            </div>
        );
    }
    return (
        <div className="border rounded-lg p-3 bg-amber-50 border-amber-200 text-sm text-amber-900 flex gap-2" data-testid="delete-impact-warning">
            <AlertTriangle className="h-4 w-4 mt-0.5 shrink-0" />
            <div>
                <div className="font-semibold">Folgendes wird mitgelöscht:</div>
                <ul className="list-disc pl-4 mt-1">
                    <li data-testid="delete-impact-bookings">{impact.in_house_bookings} Mitarbeiter-Anmeldung(en)</li>
                    <li data-testid="delete-impact-invoices">{impact.invoices} offene Sammelrechnung(en){impact.invoices ? ` (${impact.invoice_numbers.join(', ')})` : ''}</li>
                </ul>
                <div className="text-xs mt-1">Bereits in Dropbox abgelegte Rechnungs-PDFs bleiben erhalten.</div>
            </div>
        </div>
    );
}

export default DeleteImpactNotice;
